import { CircularProgress } from "@material-ui/core";
import { usePopup } from "hooks/usePopup";
import { useEffect, useState } from "react";
import {
  HiOutlineArrowRight,
  HiOutlineCalendar,
  HiOutlineChartPie,
  HiOutlineClock,
  HiOutlineExclamationCircle
} from "react-icons/hi";
import batchServiceV3 from "services/batchServiceV3";

import { formatData } from "../../../utils/formatData";
import { BatchBreakageModal } from "../../BatchBreakageModal";
import { CardContent } from "../CardContent";
import {
  BreakageCardContent,
  BreakageCardValueRow,
  BreakageDetailsButton,
  BreakageInfoContent,
  CardTitle,
  CardValue,
  CardsContainer,
  IconContent,
  InfoContent
} from "../styles";

export const HorDashCards = ({
  batchData,
  storageData,
  batchLoading,
  stockLoading
}) => {
  const { addPopup } = usePopup();
  const [batchBreakageData, setBatchBreakageData] = useState({});
  const [loadingBatchBreakage, setLoadingBatchBreakage] = useState(false);
  const [openBatchBreakage, setOpenBatchBreakage] = useState(false);
  const [scheduleDateFrom, setScheduleDateFrom] = useState(new Date());
  const [scheduleDateTo, setScheduleDateTo] = useState(new Date());

  const getBatchBreakageData = async () => {
    try {
      setLoadingBatchBreakage(true);
      const params = {
        scheduleDateFrom,
        scheduleDateTo
      };
      const { data } = await batchServiceV3.getBatchWitBreakageDash(params);

      setBatchBreakageData(formatData.formatBatchBreakageData(data));
    } catch (error) {
      const errorMessage = error?.response?.data?.msg;
      addPopup({
        type: "error",
        title: "Erro ao carregar lotes com quebra",
        description: errorMessage
      });
    } finally {
      setLoadingBatchBreakage(false);
    }
  };

  const handleOpenBatchBreakage = () => {
    setOpenBatchBreakage(true);
  };

  const handleCloseBatchBreakage = () => {
    setOpenBatchBreakage(false);
  };

  const handleChangeScheduleDate = dates => {
    const [start, end] = dates;
    setScheduleDateFrom(start);
    setScheduleDateTo(end);
  };

  useEffect(() => {
    !!scheduleDateFrom && !!scheduleDateTo && getBatchBreakageData();
  }, [scheduleDateFrom, scheduleDateTo]);

  return (
    <CardsContainer gridArea="cards">
      <CardContent loading={batchLoading}>
        <IconContent style={{ background: "#EB001B" }}>
          <HiOutlineCalendar size={18} color="#FFF" />
        </IconContent>
        <InfoContent>
          <CardTitle>Lotes vencidos</CardTitle>
          <CardValue>{batchData.dueBatches || 0}</CardValue>
        </InfoContent>
      </CardContent>

      <CardContent loading={batchLoading}>
        <IconContent style={{ background: "#FFC84E" }}>
          <HiOutlineClock size={18} color="#FFF" />
        </IconContent>
        <InfoContent>
          <CardTitle>Lotes a vencer</CardTitle>
          <CardValue> {batchData.batchesToDue || 0}</CardValue>
        </InfoContent>
      </CardContent>

      <CardContent loading={stockLoading}>
        <IconContent style={{ background: "#EB001B" }}>
          <HiOutlineExclamationCircle size={18} color="#FFF" />
        </IconContent>
        <InfoContent>
          <CardTitle>Estoque negativo</CardTitle>
          <CardValue>{storageData.length ?? 0}</CardValue>
        </InfoContent>
      </CardContent>

      <BreakageCardContent>
        {loadingBatchBreakage ? (
          <CircularProgress size={24} style={{ margin: "auto" }} />
        ) : (
          <>
            <IconContent style={{ background: "#2E656A" }}>
              <HiOutlineChartPie size={18} color="#FFF" />
            </IconContent>
            <BreakageInfoContent>
              <CardTitle>Lotes com quebras</CardTitle>
              <BreakageCardValueRow>
                <CardValue>{batchBreakageData.batchBreakageQty}</CardValue>
                <BreakageDetailsButton
                  type="button"
                  onClick={handleOpenBatchBreakage}
                >
                  Ver detalhes
                  <HiOutlineArrowRight size={15} />
                </BreakageDetailsButton>
              </BreakageCardValueRow>
            </BreakageInfoContent>
          </>
        )}
      </BreakageCardContent>
      <BatchBreakageModal
        open={openBatchBreakage}
        handleClose={handleCloseBatchBreakage}
        batchData={batchBreakageData.batchData}
        complaintsData={batchBreakageData.complaintsData}
        scheduleDateFrom={scheduleDateFrom}
        scheduleDateTo={scheduleDateTo}
        handleChangeScheduleDate={handleChangeScheduleDate}
        loading={loadingBatchBreakage}
      />
    </CardsContainer>
  );
};
